import { lazy } from "react";
import { useUIStore } from "../stores/UIStore";

const sessionKey = "lazyWithRetry";

const lazyRetry = (componentImport) => {
    return lazy(async () => {
        const hasRefreshed = globalThis.sessionStorage.getItem(`${sessionKey}`) || "false";

        try {
            globalThis.sessionStorage.setItem(`${sessionKey}`, "false");
            return await componentImport();
        } catch (error) {
            if (hasRefreshed === "false") {
                globalThis.sessionStorage.setItem(`${sessionKey}`, "true");
                useUIStore.getState().setWindowLoading(true);

                setTimeout(() => {
                    globalThis.location.reload();
                }, 50);
            }

            if (hasRefreshed === "true") throw new Error("chunkLoadError");
        }
        return await componentImport();
    });
};

export default lazyRetry;